import React, { useState, useEffect } from 'react';
import '../styling/eatglass.css';

function EatGlass() {
  const [glassShards, setGlassShards] = useState([]);
  const [shatterEffect, setShatterEffect] = useState(false);
  const [quote, setQuote] = useState("Loading...");

  useEffect(() => {
    // Generate random glass shards on mount
    const shards = Array.from({ length: 20 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      delay: Math.random() * 2,
      duration: 2 + Math.random() * 3,
    }));
    setGlassShards(shards);

    // Fetch the quote from the backend API
    fetch('/api/eatGlass')
      .then(response => response.json())
      .then(data => setQuote(data))
      .catch(error => {
        console.error('Error fetching quote:', error);
        setQuote("Backend issue!");
      });
  }, []);

  const handleClick = () => {
    setShatterEffect(true);
    setTimeout(() => setShatterEffect(false), 1000);
  };

  return (
    <div className="eatglass-container">
      <div className={`glass-panel ${shatterEffect ? 'shatter' : ''}`} onClick={handleClick}>
        <div className="glass-content">
          <h1 className="glass-title">
            <span className="glass-glow">E</span>
            <span className="glass-glow">A</span>
            <span className="glass-glow">T</span>
            <span className="glass-glow"> </span>
            <span className="glass-glow">G</span>
            <span className="glass-glow">L</span>
            <span className="glass-glow">A</span>
            <span className="glass-glow">S</span>
            <span className="glass-glow">S</span>
          </h1>
          <div className="glass-subtitle">
            A Hidden Delicacy
          </div>
          <div className="glass-divider"></div>
          <p className="glass-description">
            You've discovered the forbidden route, a crystalline realm where reality 
            fractures into infinite possibilities. Here, in the digital aether, we celebrate 
            the absurd, the hidden, and the delightfully unexpected.
          </p>
          <div className="glass-quote">
            "{quote}"
          </div>
          <button className="glass-button" onClick={handleClick}>
            Shatter Reality
          </button>
        </div>
        
        {/* Animated glass shards */}
        <div className="glass-shards">
          {glassShards.map(shard => (
            <div 
              key={shard.id}
              className="glass-shard"
              style={{
                left: `${shard.left}%`,
                animationDelay: `${shard.delay}s`,
                animationDuration: `${shard.duration}s`
              }}
            />
          ))}
        </div>
      </div>

      {/* Floating glass particles */}
      <div className="glass-particles">
        {[...Array(15)].map((_, i) => (
          <div 
            key={i} 
            className="glass-particle"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${3 + Math.random() * 4}s`
            }}
          />
        ))}
      </div>
    </div>
  );
}

export default EatGlass;
